<script lang="ts">
	import ConstitutionContent from './constitution.svx';
</script>

<div class="prose prose-blue dark:prose-invert max-w-none">
	<ConstitutionContent />
</div>
